import { apiHeliosClient } from 'src/data/api/apiHeliosClient';
import {
  EditQuestionTranslationCommand,
  EditQuestionTranslationCommandInput,
} from '@amzn/gbsa-helios-typescript-client';

/**
 * Service layer for question translation operations
 * Provides a clean API for translation-related HTTP requests
 *
 * This follows the same pattern as feedbackService and templateService for consistency
 * Uses the TypeScript client for better type safety and consistency
 */
export const translationService = {
  /**
   * Updates a question translation for a specific language
   *
   * @param data - The translation update request containing question ID, language, and content
   * @returns Promise resolving to the update response with translation details and version
   *
   * @example
   * ```typescript
   * const response = await translationService.update({
   *   programId: 'PROG1',
   *   businessUnit: 'BU1',
   *   divisionName: 'Division A',
   *   questionId: 'Q123',
   *   language: 'es',
   *   questionTranslation: {
   *     questionDetails: {
   *       title: 'Título',
   *       questionText: 'Texto de pregunta',
   *       auditInstruction: 'Instrucción',
   *       passCriteria: 'Criterios de aprobación',
   *       failCriteria: 'Criterios de fallo',
   *       justification: 'Justificación',
   *     },
   *     taskDetails: {
   *       taskName: 'Nombre de tarea',
   *       taskDescription: 'Descripción',
   *     },
   *   },
   *   subQuestionTranslations: {
   *     'subq-1': {
   *       title: 'Título',
   *       instruction: 'Instrucción',
   *       taskDetails: { ... },
   *     },
   *   },
   *   updatedBy: 'user1',
   * });
   * ```
   */
  update: (data: EditQuestionTranslationCommandInput) => {
    return apiHeliosClient.send(new EditQuestionTranslationCommand(data));
  },
};
